import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { Moon, Sun } from 'react-bootstrap-icons';

function DarkModeToggle() {
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    // Check for saved dark mode preference
    const savedMode = localStorage.getItem('darkMode');
    if (savedMode === 'true') {
      setDarkMode(true);
      document.body.classList.add('dark-mode');
    }
  }, []);

  useEffect(() => {
    // Apply dark mode class to body
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
    
    // Save preference
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  return (
    <Form.Check 
      type="switch" 
      id="dark-mode-toggle" 
      label={darkMode ? <Moon size={16} className="text-warning" /> : <Sun size={16} className="text-warning" />}
      checked={darkMode} 
      onChange={toggleDarkMode}
      className="d-flex align-items-center gap-2 mb-0"
    />
  );
}

export default DarkModeToggle;